import autoBind from 'auto-bind'

export abstract class BaseMiddleware {
  // @ts-ignore
  protected app: any

  constructor(app: any) {
    autoBind(this)
    this.app = app
  }

  public abstract default(args: any): void
}
